import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';

const CycleEventPipeLineFilters = [
	{
		displayName: 'Not Started',
		name: 'notStarted',
		filter: { status: 'notStarted' },
		icon: 'icons8-edit',
		iconStyle: { color: '#4a1e87' },
	},
	{
		displayName: 'In Progress',
		name: 'inProgress',
		filter: { status: 'inProgress' },
		icon: 'icons8-wrench',
		iconStyle: { color: STOPLIGHT_COLORS.yellowGreen },
	},
	{
		displayName: 'Completed',
		name: 'completed',
		filter: { status: 'completed' },
		icon: 'icons8-green-check-mark',
		iconStyle: { color: STOPLIGHT_COLORS.pureGreen },
	},
];

export default CycleEventPipeLineFilters;
